import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const Terms: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: November 25, 2025</p>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using CineClubs.cloud ("Platform"), you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our Platform.</p>
          </section>

          <section className="legal-section">
            <h2>2. Description of Service</h2>
            <p>CineClubs provides a platform for users to:</p>
            <ul>
              <li>Watch movies and video content</li>
              <li>Host and join live streaming sessions</li>
              <li>Create and participate in watch parties</li>
              <li>Interact with other users through chat</li>
              <li>Send virtual gifts to streamers</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. User Accounts</h2>
            <p>To access certain features, you must create an account. You are responsible for:</p>
            <ul>
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Providing accurate and current information</li>
              <li>Notifying us of any unauthorized use</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. User Conduct</h2>
            <p>You agree NOT to:</p>
            <ul>
              <li>Post illegal, harmful, or offensive content</li>
              <li>Harass, abuse, or threaten other users</li>
              <li>Violate intellectual property rights</li>
              <li>Distribute malware or engage in hacking</li>
              <li>Circumvent security features</li>
              <li>Use the service for commercial spam</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Content Rights</h2>
            <p>You retain ownership of content you create. By posting content, you grant CineClubs a non-exclusive license to use, display, and distribute your content on the Platform.</p>
          </section>

          <section className="legal-section">
            <h2>6. Subscriptions and Payments</h2>
            <p>Premium features may require payment. All payments are processed securely through third-party providers. Refunds are handled according to our refund policy.</p>
          </section>

          <section className="legal-section">
            <h2>7. Termination</h2>
            <p>We reserve the right to suspend or terminate accounts that violate these terms. You may delete your account at any time through your account settings.</p>
          </section>

          <section className="legal-section">
            <h2>8. Disclaimer</h2>
            <p>The Platform is provided "as is" without warranties of any kind. We do not guarantee uninterrupted or error-free service.</p>
          </section>

          <section className="legal-section">
            <h2>9. Contact</h2>
            <p>For questions about these Terms, contact us at: <a href="mailto:support@cineclubs.com">support@cineclubs.com</a></p>
          </section>
        </div>

        <div className="legal-back">
          <Link to="/">
            <i className="fas fa-arrow-left"></i>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Terms;
